import Countries from '@module/i18n/countries';

export const countryHelpers = {
  getCountryByCode(countryCode) {
    return Countries.find((country) => {
      return country.id === countryCode;
    });
  },

  getCountryByName(countryName) {
    return Countries.find((country) => {
      return country.label === countryName;
    });
  },
};
